/** Blob 을 파일로 다운로드. 파일명은 NFC 정규화. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename.normalize("NFC");
  // 일부 Firefox 계열에서는 anchor 가 DOM 에 연결돼 있어야 .click() 다운로드가 트리거된다.
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // 다운로드 파이프라인이 blob URL 을 비동기로 읽기 시작하므로 즉시 revoke 하면
  // 큰 파일/일부 브라우저(Edge·Windows)에서 "네트워크 오류"로 실패한다. 지연 후 해제.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
